import { t } from "i18next";
import { useContext } from "react";
import { ProductContext } from "../../App";
import {
  WIDTH_ID,
  WIDTH,
  MIN_WIDTH,
  MAX_WIDTH,
  HEIGHT_ID,
  HEIGHT,
  MIN_HEIGHT,
  MAX_HEIGHT,
  setProductSize,
  setWallSize
} from "../Scene/Scene";

import Slider from "../Slider/Slider.js";

const productConfig = {
  widthStep: 10,
  widthValue: WIDTH,
  widthEditable: true,
  widthInputTitle: "",
  widthUnit: t('unit'),
  heightStep: 10,
  heightValue: HEIGHT,
  heightEditable: true,
  heightInputTitle: "",
  heightUnit: t('unit')
};

function ProductSize() {
  const { currentProduct, setCurrentProduct, wall, setWall } = useContext(ProductContext);

  function setSize(event) {
    productConfig[event.target.id === WIDTH_ID ? "widthValue" : "heightValue"] = event.target.value;

    setProductSize(currentProduct, event.target.id, event.target.value);
    setWallSize(wall, event.target.id, event.target.value);

    setWall(wall);
    setCurrentProduct(currentProduct);
  };

  return (
    <section className="panel-container__section">
      <div className="section__title">{t('door_size')}</div>
      <div className="window-size__sliders">
        <Slider
          id={WIDTH_ID}
          title={t('width')}
          inputTitle={productConfig.widthInputTitle}
          min={MIN_WIDTH}
          max={MAX_WIDTH}
          step={productConfig.widthStep}
          value={productConfig.widthValue}
          unit={productConfig.widthUnit}
          editable={productConfig.widthEditable}
          onChange={setSize.bind(this)}
        />
        <div style={{ marginBottom: '20px' }} />
        <Slider
          id={HEIGHT_ID}
          title={t('height')}
          inputTitle={productConfig.heightInputTitle}
          min={MIN_HEIGHT}
          max={MAX_HEIGHT}
          step={productConfig.heightStep}
          value={productConfig.heightValue}
          unit={productConfig.heightUnit}
          editable={productConfig.heightEditable}
          onChange={setSize.bind(this)}
        />
      </div>
    </section>
  );
}

export default ProductSize;
